/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { pincodeHead } from "../../../../../config/constant";
import { Image, Space } from "antd";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box, TextField, TableRow, TableCell } from "@mui/material";
import clsx from "clsx";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { customPhoneValidation, emptyValidation } from "../../../../../helpers/validation";
import { NavLink } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const PincodeTable = (props) => {
    const { cityDetails, pincodeDetails,
        countryDetails, stateDetails,
        onRequestSort, sortOrder, sortBy, loadTasks, handleStateChangeField, loadMore, loadMoreContent,
        loadMoreTask, customObject, roleManagement } = props

    const [visible, setVisible] = useState(false);
    const [pincodeId, setPincodeId] = useState('');
    const [pincodeName, setPincodeName] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [cityId, setCityId] = useState('');

    const { editDetails, editError, editLoader, } = useSelector(state => state.crudReducer);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const [errorPincodeName, setErrorPincodeName] = useState(false);
    const [errorCityId, setErrorCityId] = useState(false);


    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    const emptyStateInput = () => {
        setPincodeName('');
        setCityId('');
        setStateId('');
        setCountryId('');
    }

    const onEdit = (data) => {
        setVisible(true);
        setPincodeId(data.id);
        setPincodeName(data.code);
        setStateId(data.stateId);
        dispatch({
            type: actions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: data.stateId }] }
            }
        });
        setCityId(data.cityId);
        setCountryId(data.countryId);
    }

    const emptyState = () => {
        setErrorPincodeName(false);
        setErrorCityId(false);
    }

    const dispatch = useDispatch();
    const editPincode = (e) => {
        e.preventDefault();
        let emptyPincodeName = customPhoneValidation('Pincode', pincodeName, 6);
        let emptyCityId = emptyValidation('City', cityId, 'dropDown');
        emptyState();
        if (emptyPincodeName.isValid && emptyCityId.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'pincode',
                title: "Pincode",
                id: pincodeId,
                details: {
                    code: pincodeName,
                    cityId: cityId,
                    stateId: stateId,
                    countryId: countryId
                }
            });
        } else {
            if (emptyPincodeName.errors) {
                setErrorPincodeName(emptyPincodeName.errors);
            }
            if (emptyCityId.errors) {
                setErrorCityId(emptyCityId.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
            emptyStateInput();
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setErrorPincodeName(text);
        }
    }, [editDetails, editError]);

    const onDelete = (data) => {
        setDeleteModal(true);
        setPincodeId(data.id);
        setPincodeName(data.code);
    }

    const changeCity = (value) => {
        setCityId(value);
        let a = cityDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setStateId(a[0].stateId);
            setCountryId(a[0].countryId);
        }
    }

    const handleStateChangeEdit = (id) => {
        setStateId(id);
        setCityId('');
        handleStateChangeField(id)
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={pincodeHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || pincodeDetails === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        pincodeDetails && Array.isArray(pincodeDetails) && pincodeDetails?.length > 0 ? pincodeDetails.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(pincodeHead, 0) }}><span style={{ width: getColumnWidth(pincodeHead, 0) }}>{data.code}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(pincodeHead, 1) }}><span style={{ width: getColumnWidth(pincodeHead, 1) }}>{data?.city?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(pincodeHead, 2) }}><span style={{ width: getColumnWidth(pincodeHead, 2) }}>{data?.state?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(pincodeHead, 3) }}><span style={{ width: getColumnWidth(pincodeHead, 3) }}>{data?.country?.name || '---'}</span></TableCell>
                                                <TableCell scope="row" className={clsx(classes.tableLastColumn)}>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Pincode', 'edit', 'Younote Admin') || checkCRUDPermission('Pincode', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Pincode', 'deletable', 'Younote Admin') || checkCRUDPermission('Pincode', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Pincode'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Pincode'}
                width={"360px"}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editPincode(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorPincodeName ? true : false}
                                helperText={errorPincodeName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={pincodeName}
                                onChange={(e) => setPincodeName(e.target.value)}
                            />
                            <AutoCompleteComponent
                                name={["State"]}
                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                details={stateDetails}
                                parentValue={customObject(stateDetails, stateId)}
                                onChange={(data) => handleStateChangeEdit(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                            />
                            <AutoCompleteComponent
                                name={["Dist/City/Town ", <span key={"Dist/City/Town"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Name' },
                                { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                details={cityDetails}
                                parentValue={customObject(cityDetails, cityId)}
                                onChange={(data) => changeCity(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                                parentError={errorCityId}
                            />
                            <AutoCompleteComponent
                                name={["Country"]}
                                heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                details={countryDetails}
                                parentValue={customObject(countryDetails, countryId)}
                                onChange={(data) => setCountryId(data.id)}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update & Save
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={pincodeId} loadTasks={() => loadTasks()} name={pincodeName} url={'pincode'} title={'Pincode'} visible={deleteModal} />
        </>
    );
}